import { render } from "./Tunnel.vue?vue&type=template&id=25ea3799"
import script from "./Tunnel.vue?vue&type=script&lang=js"
export * from "./Tunnel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__